import { ServiceMaker, methods, services } from "@/services";

export const createTemplateWhatsapp = payload =>
  ServiceMaker(
    `/communication/templates`,
    methods.POST,
    services.master,
    payload
  );

export const updateTemplateWhatsapp = payload =>
  ServiceMaker(
    `/communication/templates/${payload.id}`,
    methods.PUT,
    services.master,
    payload.data
  );

export const fetchWhatsappTemplateAll = (payload) =>
  ServiceMaker(
    `/communication/templates?service=${payload.service}`,
    methods.GET,
    services.master,
    payload
  );
